import React from 'react';
import { SlideContent } from '../components/canvas/SlideContent';
import { SlideFooter } from '../components/canvas/SlideFooter';
import { NudgeableGroup } from '../components/canvas/NudgeableGroup';

/**
 * Brutalist layout — raw, counter-culture, anti-design.
 * Monospace typography, hard grid, no ornamentation, no curves.
 * Footer pinned at bottom for cross-template consistency.
 */
export function BrutalistLayout({ data, fontPreset, pc }) {
  return (
    <div className="absolute inset-0">
      {/* Top-left index marker */}
      <div className="absolute top-[48px] left-[48px]">
        <div className="text-[18px] font-mono tracking-widest uppercase" style={{ color: pc.text(0.30) }}>
          MF—{String(data.slideIndex ?? 0).padStart(2, '0')}
        </div>
      </div>

      {/* Top-right corner mark */}
      <div className="absolute top-[48px] right-[48px]">
        <div className="w-[40px] h-[40px] border-t-2 border-r-2" style={{ borderColor: pc.text(0.20) }} />
      </div>

      {/* Content */}
      <NudgeableGroup groupId="content" className="absolute left-[48px] right-[48px] top-[140px] bottom-[140px] flex flex-col justify-center">
        <SlideContent
          data={data}
          fontPreset={fontPreset}
          pc={pc}
          options={{
            showFooter: false,
            showKicker: true,
            mutedOpacity: 0.50,
            subtleOpacity: 0.35,
          }}
        />
      </NudgeableGroup>

      {/* Bottom-left corner mark */}
      <div className="absolute bottom-[48px] left-[48px]">
        <div className="w-[40px] h-[40px] border-b-2 border-l-2" style={{ borderColor: pc.text(0.20) }} />
      </div>

      {/* Footer — pinned at bottom */}
      <div className="absolute bottom-[64px] left-[64px] right-[64px]">
        <SlideFooter data={data} pc={pc} />
      </div>
    </div>
  );
}
